import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { GlobalShadowStyleDirective } from '@ptl/global-components';


enum COMPONENT_STRATEGY_ENUM {
  AEM_DAM = 'AEM_DAM',
  SMALL_GROUP_DOCUMENTS = 'SMALL_GROUP_DOCUMENTS'
}

interface RadioConfigs {
  label: string;
  componentStrategy: COMPONENT_STRATEGY_ENUM;
  order: string;
}

interface FormControls {
  documentType: AbstractControl;
}

interface FormControlsAsJson {
  documentType: string;
}

@Component({
    selector: 'app-sbcs-and-agreements',
    templateUrl: './sbcs-and-agreements.component.html',
    styleUrls: ['./sbcs-and-agreements.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class SbcsAndAgreementsComponent extends GlobalShadowStyleDirective implements OnInit {
  
  @Input() radioConfigs: string;
  form: FormGroup;
  parsedData: RadioConfigs[];
  dataMap: { [key: string]: RadioConfigs[] };

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  get parsedRadioConfigs(): RadioConfigs[] {
    try {
      return JSON.parse(this.radioConfigs) as unknown as RadioConfigs[];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  get formControls(): FormControls {
    return this.form as unknown as FormControls;
  }
  get formValuesAsJson(): FormControlsAsJson {
    return this.form.value as unknown as FormControlsAsJson;
  }

  ngOnInit(): void {
      this.form = this.fb.group({
        documentType: this.fb.control(null)
      })

      this.parsedData = this.parsedRadioConfigs.sort( (a,b) => parseInt(a.order) - parseInt(b.order) );
      
      this.dataMap = {};
      this.parsedData.forEach( i => {
        
        if (!this.dataMap[i.componentStrategy]) {
          this.dataMap[i.componentStrategy] = [];
        }

        this.dataMap[i.componentStrategy].push(i);

      })

      console.log(this.dataMap);
  }

  trackByIndex(index: number): number {
    return index;
  }
  trackByOrder(index: number, item: { order: any }): number {
    return item.order;
  }
}
